/**
 * What the legal page tells search engines and link previews — ONE copy, read by today's page (src/pages/Legal.tsx)
 * and its rebuild in the new design (src/design/pavilion/pages/legal/), the way src/config/aboutSeo.ts serves both
 * about pages (PV5a, design record §7b lane A).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/legal"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so each
 * stays one line. The structured data keeps JSON-style quoted keys, which the extractor does not read.
 */
export const LEGAL_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Legal Information | prest0",
  "description": "Access prest0's legal documents including our privacy policy, terms of service, and cookie policy to understand how we protect your data.",
  "url": "https://prest0.ai/legal",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://prest0.ai/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Legal Information",
        "item": "https://prest0.ai/legal"
      }
    ]
  }
} as const;

/** Where search files the legal page, whichever address served it. */
export const LEGAL_CANONICAL_URL = 'https://prest0.ai/legal';

/** The props both legal pages hand to <SeoHead>. */
export const LEGAL_SEO = {
  title: 'Legal Information | prest0',
  tabTitle: 'legal',
  description: "Access prest0's legal documents: privacy policy, terms of service, and cookie policy governing our enterprise legal AI platform.",
  keywords: 'prest0, legal, privacy policy, terms of service, cookie policy, enterprise legal AI compliance, data protection',
  canonicalUrl: LEGAL_CANONICAL_URL,
  structuredData: LEGAL_STRUCTURED_DATA,
} as const;
